import { NotificationsList, NotificationsListPayload } from 'queries/notifications/contract';

export const notificationsListMock: NotificationsList = [
  {
    frequency: 'DAILY',
    model_id: 'bce31e2c-70fd-42a5-b66a-8792b4155666',
    id: 'c1da0345-bf34-4991-9867-14b0fa3c3f5a',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '38436401-6671-4c0b-ba07-c7e9967f8162',
  },
  {
    frequency: 'DAILY',
    model_id: 'bce31e2c-70fd-42a5-b66a-8792b4155666',
    id: '1484188c-9744-4e10-876e-d524c8b4249d',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '38436401-6671-4c0b-ba07-c7e9967f8162',
  },
  {
    frequency: 'DAILY',
    model_id: '4e4c4e58-7da8-4956-8490-5dc0ca540bbd',
    id: '3cb9d8ae-f57a-4b21-93eb-70a1dbd00cef',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '87012e2e-6e6d-4f5b-9006-a6a74cdb1f2d',
  },
  {
    frequency: 'DAILY',
    model_id: '4e4c4e58-7da8-4956-8490-5dc0ca540bbd',
    id: '5b22f680-76fa-40f4-be8b-05134d962d58',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '87012e2e-6e6d-4f5b-9006-a6a74cdb1f2d',
  },
  {
    frequency: 'DAILY',
    model_id: 'bce31e2c-70fd-42a5-b66a-8792b4155666',
    id: '4de1cf2d-7e9e-41fe-9b08-0a3a9aa083bc',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '38436401-6671-4c0b-ba07-c7e9967f8162',
  },
  {
    frequency: 'DAILY',
    model_id: '4e4c4e58-7da8-4956-8490-5dc0ca540bbd',
    id: 'ba08a3a8-544a-40fa-83f7-968c01535365',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '87012e2e-6e6d-4f5b-9006-a6a74cdb1f2d',
  },
  {
    frequency: 'DAILY',
    model_id: 'bce31e2c-70fd-42a5-b66a-8792b4155666',
    id: '495c3339-2265-44e9-924d-1d4bb08a1011',
    model_label: 'FC - Rundown Tank Fill-up/Drainage Issue',
    asset_id: '38436401-6671-4c0b-ba07-c7e9967f8162',
  },
];

export const notificationListMock: NotificationsListPayload = [
  {
    id: 'c1da0345-bf34-4991-9867-14b0fa3c3f5a',
    description: 'MV27 compressor',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'category',
        frequencies: ['by_asset'],
      },
      {
        notification_type: 'alarms',
        alarm_field_type: 'model',
        frequencies: ['wednesdays', 'fridays'],
      },
    ],
  },
  {
    id: '1484188c-9744-4e10-876e-d524c8b4249d',
    description: 'MV24 pump',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'category',
        frequencies: ['daily'],
      },
    ],
  },
  {
    id: '3cb9d8ae-f57a-4b21-93eb-70a1dbd00cef',
    description: 'MV27 Electrical Generator',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'all',
        frequencies: ['daily'],
      },
    ],
  },
  {
    id: '5b22f680-76fa-40f4-be8b-05134d962d58',
    description: 'MV27 GTC',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'category',
        frequencies: ['daily'],
      },
      {
        notification_type: 'alarms',
        alarm_field_type: 'model',
        frequencies: ['daily'],
      },
    ],
  },
  {
    id: '4de1cf2d-7e9e-41fe-9b08-0a3a9aa083bc',
    description: 'MV22 Crude Oil Treating and Stabilizating',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'model',
        frequencies: ['daily'],
      },
    ],
  },
  {
    id: 'ba08a3a8-544a-40fa-83f7-968c01535365',
    description: 'MV24 Flare/Vent',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'all',
        frequencies: ['daily'],
      },
    ],
  },
  {
    id: '495c3339-2265-44e9-924d-1d4bb08a1011',
    description: 'MV27',
    subjects: [
      {
        notification_type: 'alarms',
        alarm_field_type: 'all',
        frequencies: ['by_asset'],
      },
    ],
  },
];
